const compare = function (original, target) {
  if (original === target) return true
  if (!(original instanceof Object) || !(target instanceof Object)) return false
  if (original.constructor !== target.constructor) return false

  for (const key in original) {
    if (!target.hasOwnProperty(key)) return false
    if (!original.hasOwnProperty(key) || original[key] === target[key]) continue
    if (typeof original[key] !== 'object') return false
    // this. 제거. Table Data compareObject 시 에러 보완.
    if (!compare(original[key], target[key])) return false
  }

  for (const key2 in target) {
    if (target.hasOwnProperty(key2) && !original.hasOwnProperty(key2)) return false
  }

  return true
}

export default compare
